import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import type { RefObject } from "react";
import type { Group } from "three";

gsap.registerPlugin(ScrollTrigger);

let _invalidate: (() => void) | null = null;
export const setInvalidate = (fn: (() => void) | null) : void => {
    _invalidate = fn;
};

export const animateWithGsap = (
    target: gsap.DOMTarget,
    animationProps: gsap.TweenVars,
    scrollProps?: ScrollTrigger.Vars,
) => {
    gsap.to(target, {
        ...animationProps,
        scrollTrigger: {
            trigger: target,
            toggleActions: "restart reverse restart reverse",
            start: "top 85%",
            ...scrollProps,
        },
    });
};

export const animateWithGsapTimeline = (
    timeline: gsap.core.Timeline,
    rotationRef: RefObject<Group>,
    rotationState: number,
    firstTarget: gsap.TweenTarget,
    secondTarget: gsap.TweenTarget,
    animationProps: gsap.TweenVars,
) => {
    const onUpdate = () => _invalidate?.();

    timeline.to(rotationRef.current.rotation, {
        y: rotationState,
        duration: 1,
        ease: "power2.inOut",
        onUpdate,
    });

    timeline.to(
        firstTarget,
        {
            ...animationProps,
            ease: "power2.inOut",
            onUpdate,
        },
        "<",
    );

    timeline.to(
        secondTarget,
        {
            ...animationProps,
            ease: "power2.inOut",
            onUpdate,
        },
        "<",
    );
};
